import { MapPin, MessageCircle, Clock, Phone, ExternalLink } from "lucide-react";
import { WA_GENERAL, ADDRESS, PHONE_DISPLAY, MAPS_URL } from "@/data/products";

export default function Footer() {
  return (
    <footer id="contacto" className="border-t border-[#1A2235]" data-testid="footer-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 pt-20 md:pt-28 pb-10">
        <div className="font-display font-black uppercase tracking-tighter leading-none text-outline select-none text-[clamp(4rem,17vw,15rem)]" style={{ fontWeight: 900 }}>
          ANGORA
        </div>

        <div className="grid md:grid-cols-12 gap-10 md:gap-16 mt-10 md:mt-14 border-t border-[#1A2235] pt-12 md:pt-16">
          <div className="md:col-span-5">
            <h3 className="font-display text-2xl md:text-3xl font-bold tracking-tight mb-6">Visítanos en planta</h3>
            <div className="flex gap-6 items-start">
              <img src="/assets/negocio.jpg" alt="Fachada de ANGORA MATERIALES"
                className="w-36 md:w-44 aspect-[4/3] object-cover rounded-sm border border-[#1A2235]" loading="lazy"
                data-testid="footer-business-photo" />
              <div className="space-y-4 text-sm text-[#8B95A5]">
                <p className="flex gap-3 leading-relaxed">
                  <MapPin size={18} className="text-[#FF7A00] shrink-0 mt-0.5" />
                  <span>{ADDRESS}</span>
                </p>
                <p className="flex gap-3">
                  <Clock size={18} className="text-[#FF7A00] shrink-0" />
                  <span>Lun–Vie 8:00–18:00 · Sáb 8:00–14:00</span>
                </p>
                <p className="flex gap-3">
                  <Phone size={18} className="text-[#FF7A00] shrink-0" />
                  <a href="tel:+526675723329" className="hover:text-white transition-colors duration-200" data-testid="footer-phone-link">{PHONE_DISPLAY}</a>
                </p>
                <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-maps-link"
                  className="inline-flex items-center gap-2 text-[#FF7A00] hover:text-white transition-colors duration-200 font-medium">
                  Cómo llegar <ExternalLink size={14} />
                </a>
              </div>
            </div>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-display text-2xl md:text-3xl font-bold tracking-tight mb-6">Cotiza hoy mismo</h3>
            <p className="text-sm text-[#8B95A5] leading-relaxed mb-6 max-w-sm">
              Mándanos tu lista de materiales por WhatsApp y te respondemos con precio,
              disponibilidad y tiempo de entrega el mismo día.
            </p>
            <a href={WA_GENERAL} target="_blank" rel="noopener noreferrer" data-testid="footer-quote-button"
              className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1eb856] text-white font-semibold px-7 py-4 rounded-sm transition-colors duration-200">
              <MessageCircle size={18} /> WhatsApp {PHONE_DISPLAY}
            </a>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-display text-2xl md:text-3xl font-bold tracking-tight mb-6">Materiales</h3>
            <ul className="space-y-3 text-sm text-[#8B95A5]">
              {["Láminas y rollos", "Perfiles y tubos", "Vigas y placas", "Varilla y alambre"].map((m) => (
                <li key={m} className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-[#FF7A00] rounded-full" /> {m}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1A2235] mt-14 pt-8 pb-16 md:pb-0 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#8B95A5]">
          <span>© 2017 ANGORA MATERIALES · Aceros + Construcción + Ferretería</span>
          <span className="font-mono-ind uppercase tracking-widest">Hecho en Los Mochis, Sinaloa</span>
        </div>
      </div>
    </footer>
  );
}
